import './post_view.js.coffee'
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.InstagramPostView extends Monitoring.Reports.Campaign.PostView
  className: "instagram-content"
  preview: JST['backbone/templates/monitoring/reports/campaign/post_preview_instagram']
